import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from 'app/store'
import { onSignOutSuccess } from 'store/auth/sessionSlice'
import { initialState, setUser } from 'store/auth/userSlice'

const MAX_SAFE_AUTH_TOKEN_LENGTH = 6000

const clearOversizedAuthState = () => {
    localStorage.removeItem(PERSIST_STORE_NAME)
    store.dispatch(onSignOutSuccess())
    store.dispatch(setUser(initialState))
}

const normalizeToken = (token) => {
    if (!token) {
        return ''
    }

    if (String(token).length > MAX_SAFE_AUTH_TOKEN_LENGTH) {
        clearOversizedAuthState()
        return ''
    }

    return token
}

export const getAccessToken = () => {
    // Prefer the live Redux token because entity switch issues a fresh JWT
    // before redux-persist has necessarily flushed localStorage.
    const stateToken = store.getState()?.auth?.session?.token

    if (stateToken) {
        return normalizeToken(stateToken)
    }

    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)
    const persistedToken = persistData?.auth?.session?.token

    if (persistedToken) {
        return normalizeToken(persistedToken)
    }

    return ''
}
